<template>
    <div class="visual-box">
        <div class="box-side">
            <div class="box-side-top">
                <p class="con-title" style="color:#fff;text-align: left;">
                    <span></span>项目巡查
                </p>
                <div class="box-side-top-con">
                    <div style="display:flex;flex-wrap:wrap;padding-right: 1vw;">
                        <p class="con-title" style="color:#fff;text-align: left;">
                            <span style="width:6px;height:6px;"></span>公司巡查
                        </p>
                        <div class="ins">
                            <p style="flex:1;text-align: right;padding-right:0.5vw;">累计巡查</p>
                            <div class="img">
                                {{insData.entAllQsCount}}次
                            </div>
                        </div>
                        <div class="ins">
                            <p style="flex:1;text-align: right;padding-right:0.5vw;">本月巡查</p>
                            <div class="img">
                                {{insData.entMonthQsCount}}次
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div style="display:flex;flex-wrap:wrap;padding-right: 1vw;">
                        <p class="con-title" style="color:#fff;text-align: left;">
                            <span style="width:6px;height:6px;"></span>监理巡查
                        </p>
                        <div class="ins">
                            <p style="flex:1;text-align: right;padding-right:0.5vw;">累计巡查</p>
                            <div class="img bgPro">
                                {{insData.projectAllQsCount}}次
                            </div>
                        </div>
                        <div class="ins">
                            <p style="flex:1;text-align: right;padding-right:0.5vw;">本月巡查</p>
                            <div class="img bgPro">
                                {{insData.projectMonthQsCount}}次
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-side-con2">
                <p class="con-title" style="color:#fff;text-align: left;">
                    <span></span>项目进度
                </p>
                <div class="box-side-top-con" style="padding:1vh;">
                    <div class="table-head">
                        <p style="width:50%;">单位名称</p>
                        <!-- <p style="width:30%;">合同名称</p> -->
                        <p style="width:50%;">进度产值</p>
                    </div>
                    <div class="table-con">
                        <ul>
                            <li class="table-con-li" v-for="(item,index) in progressList" :key="index">
                                <p style="width:50%;">
                                    <span class="nowrap">{{item.projectName}}</span>
                                </p>
                                <!-- <p style="width:30%;">
                                    <span class="nowrap">合同名称合同名称合同名称</span>
                                </p> -->
                                <p style="width:50%;">
                                    <el-progress :text-inside="true" :stroke-width="14" :percentage="parseFloat(item.val)"></el-progress>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-mid">
            <div class="box-mid-head">
                <p>
                    <span>在册人数：</span>
                    <span style="color:#4AFFFF;">{{person.zaiCeCount}}</span>
                </p>
                <p>
                    <span>在职人数：</span>
                    <span style="color:#4AFFFF;">{{person.zaiZhiCount}}</span>
                </p>
                <p>
                    <span>在场人数：</span>
                    <span style="color:#4AFFFF;">{{person.zaiChangCount}}</span>
                </p>
            </div>
            <div class="box-mid-dut">
                <p class="con-title" style="color:#fff;text-align: left;">
                    <span></span>履职效能
                </p>
                <div class="box-con-second">
                    <div class="table-head">
                        <p style="width:25%;">姓名</p>
                        <p style="width:25%;">分管合同</p>
                        <p style="width:25%;">阶段填报</p>
                        <p style="width:25%;">未录阶段</p>
                    </div>
                    <div class="table-con">
                        <ul :class="{anim1:animate1==true}">
                            <li class="table-con-li" v-for="(item,index) in effList" :key="index">
                                <p style="width:25%;">
                                    <span class="nowrap">{{item.username}}</span>
                                </p>
                                <p style="width:25%;">
                                    <span class="nowrap">{{item.contractCount}}</span>
                                </p>
                                <p style="width:25%;">
                                    <el-progress :text-inside="true" :stroke-width="14" :percentage="parseFloat(item.tianxieEfficient)"></el-progress>
                                </p>
                                <p style="width:25%;">
                                    <el-progress :text-inside="true" :stroke-width="14" color="#F53F8C" :percentage="parseFloat(item.weiluEfficient)"></el-progress>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="box-mid-dev">
                <p class="con-title" style="color:#fff;text-align: left;">
                    <span></span>设备监测
                </p>
                <div class="box-con-second" style="display:flex;">
                    <div class="dev-item" v-for="(item,index) in devList" :key="index">
                        <div style="width:100%;height:12vh;position: relative;">
                            <img src="../../assets/image/visual/dev-num.gif" style="max-width:100%;height:12vh;" />
                            <p class="dev-item-num">{{item.total}}台</p>
                        </div>
                        <p class="name" v-if="item.type=='1'">考勤机</p>
                        <p class="name" v-else-if="item.type=='2'">项目监控</p>
                        <p class="name" v-else-if="item.type=='3'">人货电梯</p>
                        <p class="num">
                            <span style="font-size:12px;color:#fff;">在线：{{item.online}}</span>
                            <span style="font-size:12px;color:#fff;">离线：{{item.offline}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-side">
            <div class="box-side-r1">
                <p class="con-title" style="color:#fff;text-align: left;">
                    <span></span>安康码管控
                </p>
                <div class="box-side-top-con" style="padding-top:1vh;">
                    <div style="display:flex;flex-wrap:wrap;padding-right: 1vw;height:50%;width:100%;position: relative;">
                        <p class="con-title" style="color:#fff;position: relative;justify-content: center;">
                            累计统计登记人数 {{anKang.CumulativeDay}}
                        </p>
                        <div style="width:100%;height:calc( 100% - 4vh );position: relative;display:flex;">
                            <div style="width:57%;height:100%;position: relative;">
                                <div class="hight-Bar" id="bar1"></div>
                            </div>
                            <div style="width:43%;height:100%;position: relative;display: flex;align-content: space-around;flex-wrap: wrap;">
                                <p style="width:100%;text-align: left;">
                                    <span class="dot-vis" style="background: #0CCF93;"></span> 正常绿码  {{anKang.green1}}
                                </p>
                                <p style="width:100%;text-align: left;">
                                    <span class="dot-vis" style="background: #F8DA2A;"></span> 异常黄码  {{anKang.yellow1}}
                                </p>
                                <p style="width:100%;text-align: left;">
                                    <span class="dot-vis" style="background: #FB2121;"></span> 异常红码  {{anKang.red1}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style="display:flex;flex-wrap:wrap;padding-right: 1vw;height:50%;width:100%;position: relative;">
                        <p class="con-title" style="color:#fff;justify-content: center;position: relative;">
                            当月统计登记人数 {{anKang.inCumulative}}
                        </p>
                        <div style="width:100%;height:calc( 100% - 4vh );position: relative;display:flex;">
                            <div style="width:57%;height:100%;position: relative;">
                                <div class="hight-Bar" id="bar2"></div>
                            </div>
                            <div style="width:43%;height:100%;position: relative;display: flex;align-content: space-around;flex-wrap: wrap;">
                                <p style="width:100%;text-align: left;">
                                    <span class="dot-vis" style="background: #0CCF93;"></span> 正常绿码  {{anKang.green2}}
                                </p>
                                <p style="width:100%;text-align: left;">
                                    <span class="dot-vis" style="background: #F8DA2A;"></span> 异常黄码  {{anKang.yellow2}}
                                </p>
                                <p style="width:100%;text-align: left;">
                                    <span class="dot-vis" style="background: #FB2121;"></span> 异常红码  {{anKang.red2}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-side-r2">
                <p class="con-title" style="color:#fff;text-align: left;">
                    <span></span>岗位效能
                </p>
                <div class="box-side-top-con" style="padding-top:1vh;">
                    <ul style="width:100%;position: relative;" :class="{anim:animate==true}">
                        <li class="postEff" v-for="(item,index) in effPostList" :key="index">
                            <p class="con-title" style="color:#fff;text-align: left;color:#37AAB2;align-items: flex-start;">
                                {{item.projectName}}
                            </p>
                            <div style="width:100%;height:calc( 100% - 4.5vh );display:flex;padding:0 1vh;">
                                <div style="width:33%;height:100%;display:flex;flex-wrap: wrap;align-items: flex-start;align-content: flex-start;">
                                    <p style="width:100%;text-align: center;height: 4vh;">监理工程师</p>
                                    <p style="width:100%;text-align: center;height: 4vh;" v-if="''!=item.post1.name">{{item.post1.name+' 出勤率'+item.post1.monthAttendance+'%'}}</p>
                                </div>
                                <div style="width:33%;height:100%;display:flex;flex-wrap: wrap;align-content: flex-start;align-items: flex-start;">
                                    <p style="width:100%;text-align: center;height: 4vh;">项目经理</p>
                                    <p style="width:100%;text-align: center;height: 4vh;" v-if="''!=item.post2.name">{{item.post2.name+' 出勤率'+item.post2.monthAttendance+'%'}}</p>
                                </div>
                                <div style="width:33%;height:100%;display:flex;flex-wrap: wrap;align-content: flex-start;align-items: flex-start;">
                                    <p style="width:100%;text-align: center;height: 4vh;">总监代表</p>
                                    <p style="width:100%;text-align: center;height: 4vh;" v-if="''!=item.post3.name">{{item.post3.name+' 出勤率'+item.post3.monthAttendance+'%'}}</p>
                                </div>
                            </div>
                            <div class="line" style="margin:0 auto;"></div>
                        </li>
                    </ul>
                </div>
            </div>
            <img src="../../assets/image/visual/small.png" @click="toSmall" style="position: absolute;right:20px;top:5px;width:4vh;height:4vh;cursor: pointer;" />
        </div>
    </div>
</template>

<script>
import HighCharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
    data(){
        return{
            groupId:'',
            insData:{
                entMonthQsCount:0,
                projectMonthQsCount:0,
                entAllQsCount:0,
                projectAllQsCount:0
            },
            effList:[],//履职效能
            progressList:[],//项目进度
            anKang:{   //安康码
                CumulativeDay: 0,
                green1: 0,
                green2: 0,
                inCumulative: 0,
                red1: 0,
                red2: 0,
                yellow1: 0,
                yellow2: 0,
            },
            person:{ //人员数量
                zaiCeCount:0,
                zaiZhiCount:0,
                zaiChangCount:0
            },
            devList:[],//设备统计列表
            effPostList:[],//岗位效能

            animate:false,
            timer:undefined,
            animate1:false,
            timer1:undefined,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        if(this.timer){
            window.clearInterval(this.timer)
        }
        if(this.timer1){
            window.clearInterval(this.timer1)
        }
        this.getIns()
        this.getEff()
        this.getProgress()
        this.getAnKang()
        this.getPersonNum()
        this.getDevList()
        this.getEffPost()
        this.setAllAn()

        this.setMonthAn()
        var _self = this;
        document.onkeydown = function(e){
            var key = window.event.keyCode;
            if(key == 27 && _self.$route.path=='/visualEntBig'){
                e.preventDefault();	
                _self.toSmall()
            }
        }
        // setTimeout(function(){
        //     let element = document.documentElement;
        //     if (element.requestFullscreen) {
        //         element.requestFullscreen();
        //     } else if (element.webkitRequestFullScreen) {
        //         element.webkitRequestFullScreen();
        //     } else if (element.mozRequestFullScreen) {
        //         element.mozRequestFullScreen();
        //     } else if (element.msRequestFullscreen) {
        //         element.msRequestFullscreen();
        //     }
        // },100)
        
    },
    methods:{

        //获取巡查数据
        getIns(){
            var that = this
            myHttp.selectQsCount({
                entId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.insData = data
                }
            })
        },

        /**
         * 履职效能
         */
        getEff(){
            var that = this
            myHttp.selectContractEfficiency({
                entId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.contractInfo||[]
                    that.effList = list
                    setTimeout(function(){
                        that.timer1 = setInterval(that.scroll1,2000) // 履职效能滚动
                    },1000)
                }
            })
        },
        //获取项目进度
        getProgress(){
            var that = this
            myHttp.progressProduction({
                entId:this.groupId,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.ProProjectSettlementTotal||[]
                    for(var i=0;i<list.length;i++){
                        list[i].val = (parseFloat(list[i].monthPay)/parseFloat(list[i].totalValue)*100).toFixed(2)
                    }
                    that.progressList = list
                }
            })
        },
        //获取人员数据
        getPersonNum(){
            var that = this
            myHttp.statisticsPeople({
                entId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.person = data
                }
            })
        },
        //获取设备统计
        getDevList(){
            var that = this
            myHttp.equipMonitor({
                entId:this.groupId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    that.devList = list
                }
            })
        },

        //获取安康码
        getAnKang(){
            var that = this
            myHttp.anKangCodeByGroupId({
                groupId:this.groupId,
                joinType:'3'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.anKang = data
                    that.setAllAn()
                    that.setMonthAn()
                }
            })
        },
        //获取岗位功能
        getEffPost(){
            var that = this
            myHttp.positionEfficiency({
                entId:this.groupId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data
                    for(var i=0;i<list.length;i++){
                        list[i].post1 = {name:'',monthAttendance:''}
                        if(list[i].positionMap['总监工程师'].length>0){
                            list[i].post1 = {
                                name:list[i].positionMap['总监工程师'][0].personName,
                                monthAttendance:list[i].positionMap['总监工程师'][0].monthAttendance
                            }
                        }
                        list[i].post2 = {name:'',monthAttendance:''}
                        if(list[i].positionMap['项目经理'].length>0){
                            list[i].post2 = {
                                name:list[i].positionMap['项目经理'][0].personName,
                                monthAttendance:list[i].positionMap['项目经理'][0].monthAttendance
                            }
                        }
                        list[i].post3 = {name:'',monthAttendance:''}
                        if(list[i].positionMap['总监代表'].length>0){
                            list[i].post3 = {
                                name:list[i].positionMap['总监代表'][0].personName,
                                monthAttendance:list[i].positionMap['总监代表'][0].monthAttendance
                            }
                        }
                    }
                    that.effPostList  = list
                    // console.log(list)
                    setTimeout(function(){
                        that.timer = setInterval(that.scroll,3000) // 班组考勤滚动
                    },1000)
                }
            })
        },
        //累计统计安康码
        setAllAn(){
            // var data = this.ageBar
            HighCharts.chart('bar1', {
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    marginBottom: 10,
                    marginTop:10
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                colors:['#0CCF93','#ffffff'],
                xAxis: {
                    type: 'category',
                    // labels: {
                    //     rotation: -45  // 设置轴标签旋转角度
                    // },
                    title: {
                        //text: '(单位：岁)',
                        align:'high',
                        style:{
                            fontSize:'10'
                        }
                    },
                    lineColor:'#3A85E0',
                    labels:{
                        style:{
                            color:'#000000'
                        }
                    },
                },
                yAxis: {
                    // min: 0,
                    title: {
                        text: '',
                        align:'high',
                    },
                    minorGridLineColor:'#000000',
                    minorTickColor:'#3A85E0',
                    gridLineColor:'#000000',
                    lineColor:'#3A85E0',
                    lineWidth:1,
                    labels:{
                        style:{
                            color:'#ffffff'
                        }
                    },
                    maxPadding: 0.2,
                    tickInterval:10
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.y:.0f} 人</b>',
                    headerFormat:'{series[0].center[1]}<br/>'
                },
                series: [{
                    name: '',
                    borderRadius:'0',
                    maxPointWidth:15,
                    data: [
                        // ['正常绿码', 500],
                        // ['异常黄码', 86],
                        // ['异常红码', 0],
                        {'color':'#0CCF93','y':parseInt(this.anKang.green1),'name':'正常绿码'},
                        {'color':'#F8DA2A','y':parseInt(this.anKang.yellow1),'name':'异常黄码'},
                        {'color':'#FB2121','y':parseInt(this.anKang.red1),'name':'异常红码'},
                    ],
                }]
            });
        },
        //本月统计安康码
        setMonthAn(){
            HighCharts.chart('bar2', {
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    marginBottom: 10,
                    marginTop:10
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                colors:['#0CCF93','#ffffff'],
                xAxis: {
                    type: 'category',
                    // labels: {
                    //     rotation: -45  // 设置轴标签旋转角度
                    // },
                    title: {
                        //text: '(单位：岁)',
                        align:'high',
                        style:{
                            fontSize:'10'
                        }
                    },
                    lineColor:'#3A85E0',
                    labels:{
                        style:{
                            color:'#000000'
                        }
                    },
                },
                yAxis: {
                    // min: 0,
                    title: {
                        text: '',
                        align:'high',
                    },
                    minorGridLineColor:'#000000',
                    minorTickColor:'#3A85E0',
                    gridLineColor:'#000000',
                    lineColor:'#3A85E0',
                    lineWidth:1,
                    labels:{
                        style:{
                            color:'#ffffff'
                        }
                    },
                    maxPadding: 0.2,
                    tickInterval:10
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.y:.0f} 人</b>',
                    headerFormat:'{series[0].center[1]}<br/>'
                },
                series: [{
                    name: '',
                    borderRadius:'0',
                    maxPointWidth:15,
                    data: [
                        // ['正常绿码', 500],
                        // ['异常黄码', 86],
                        // ['异常红码', 0],
                        {'color':'#0CCF93','y':this.anKang.green2,'name':'正常绿码'},
                        {'color':'#F8DA2A','y':this.anKang.yellow2,'name':'异常黄码'},
                        {'color':'#FB2121','y':this.anKang.red2,'name':'异常红码'},
                    ],
                }]
            });
        },

        //岗位效能滚动效果
        scroll(){
            if(this.effPostList.length>2){
                var that = this
                this.animate=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                    this.effPostList.push(this.effPostList[0]);
                    this.effPostList.shift();
                    this.animate = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer)
            }
        },
        //履职效能滚动效果
        scroll1(){
            if(this.effList.length>8){
                var that = this
                this.animate1=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                    this.effList.push(this.effList[0]);
                    this.effList.shift();
                    this.animate1 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer1)
            }
        },

        //跳转
        toSmall(){
            // let routeUrl = this.$router.resolve({
            //     name: "visualEntBig",
            // });
            // window.open(routeUrl .href, '_blank');
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            this.$router.push({path:'/visualEnt'})
        },

    }
}
</script>

<style scoped>
    *{
        color:#fff;
    }
    .visual-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-content: flex-start;
        align-items: flex-start;
        background: #000;
        max-height: 100vh;
    }
    .box-side{
        width: 30%;
        height: 100vh;
        position: relative;
        padding: 2vh;
        display: flex;
        flex-wrap: wrap;
        /* max-height: 100vh; */
    }
    .box-mid{
        width: 40%;
        height: 100vh;
        position: relative;
        padding: 2vh 0;
        display: flex;
        flex-wrap: wrap;
    }
    .box-side-top{
        width: 100%;
        height: 50%;
        position: relative;
        background: url('../../assets/image/visual/viaul-bg1.png');
        background-size: 100% 100%;
    }
    .con-title{
        color: rgb(255, 255, 255);
        text-align: left;
        width: 100%;
        height: 4vh;
        display: flex;
        align-items: center;
        align-content: center;
        padding: 0 1vw;
    }
    .con-title span,.con-title span{
        width:16px;
        height:16px;
        border-radius: 50%;
        display: inline-block;
        background: #52FFFF;
        margin-right: 1vw;
    }
    .box-side-top-con{
        width: 100%;
        height: calc( 100% - 4vh );
        position: relative;
        padding-top: 2vh;
        overflow: hidden;
    }
    .box-side-top-con .ins{
        width:50%;
        height:clac( 100% - 4vh );
        display:flex;
        align-items: center;
        align-content: center;
        padding: 0 1vh;
    }
    .box-side-top-con .ins .img{
        width: 10vh;
        height: 10vh;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        background: url('../../assets/image/visual/ins1.gif');
        background-size: 100% 100%;
    }
    .box-side-top-con .ins .bgPro{
        background: url('../../assets/image/visual/ins2.gif');
        background-size: 100% 100%;
    }
    .box-side-top-con .line{
        width: 70%;
        height: 3px;
        position: relative;
        background: url('../../assets/image/visual/line.png');
        background-size: 100% 100%;
        margin-top: 2.5vh;
        margin-bottom: 1.5vh;
        margin-left: 15%;
    }
    .box-side-con2{
        width: 100%;
        height: calc( 50% - 2vh );
        position: relative;
        margin-top: 2vh;
        background: url('../../assets/image/visual/viaul-bg1.png');
        background-size: 100% 100%;
    }
    .table-head{
        width: 100%;
        height: 4vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .table-con{
        width: 100%;
        height: calc( 100% - 4vh );
        position: relative;
        overflow: hidden;
    }
    .table-con-li{
        width: 100%;
        height: 4vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .table-con-li p{
        padding:0 1vh;
    }
    .table-con-li span{
        display: inline-block;
        width: 100%;
        position: relative;
        font-size: 1.6vh;
    }
    


    .box-mid-head{
        width: 100%;
        height: 10vh;
        position: relative;
        background: url('../../assets/image/visual/viaul-bg2.png');
        background-size: 100% 100%;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 0 1vw;
    }
    .box-mid-head p{
        width: 33.33%;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .box-mid-dut{
        width: 100%;
        height: calc( 100% - 39.5vh );
        position: relative;
        margin-top: 1.5vh;
        background: url('../../assets/image/visual/viaul-bg3.png');
        background-size: 100% 100%;
    }
    .box-con-second{
        width: 100%;
        height: calc( 100% - 4vh );
        position: relative;
        padding-top: 1vh;
    }


    .box-mid-dev{
        width: 100%;
        height: 26.5vh;
        position: relative;
        margin-top: 1.5vh;
        background: url('../../assets/image/visual/viaul-bg4.png');
        background-size: 100% 100%;
    }
    .dev-item{
        width: 25%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding:0 1vh 1vh;
        align-content: flex-start;
        align-items: flex-start;
    }
    .dev-item-num{
        width:100%;
        height:100%;
        top: 0;
        left: 0;
        position: absolute;
        display:flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .dev-item .name{
        width: 100%;
        height: 5vh;
        position: relative;
        text-align: center;
        padding-top: 1vh;
    }
    .dev-item .num{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        padding: 0 0.5vw;
    }
    .hight-Bar{
        width: 100%;
        height: 100%;
        position: relative;
    }

    .box-side-r1{
        width: 100%;
        height: calc( 50% - 1.5vh );
        position: relative;
    }
    .box-side-r1{
        width: 100%;
        height: calc( 50% - 1.5vh );
        position: relative;
        background: url('../../assets/image/visual/viaul-bg1.png');
        background-size: 100% 100%;
    }
    .box-side-r2{
        width: 100%;
        height: calc( 50% - 1.5vh );
        position: relative;
        margin-top: 3vh;
        background: url('../../assets/image/visual/viaul-bg1.png');
        background-size: 100% 100%;
    }
    .dot-vis{
        width:12px;
        height:12px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 1vw;
        margin-left: 1vw;
    }
    .postEff{
        width: 100%;
        height: 17vh;
        position: relative;
    }

    .anim{
        transition: all 1s;
        margin-top: -17vh;
    }
    .anim1{
        transition: all 1s;
        margin-top: -4vh;
    }
</style>

<style>
    @import '../../assets/css/common.css';
    .table-con .el-progress-bar__innerText{
        top: -3px;
    }
    .highcharts-credits{
        display: none;
    }
</style>